
















import { Component, Vue } from 'vue-property-decorator';
import { openURL } from 'quasar';

@Component
export default class TryMobileBanner extends Vue {

    get config() {
        return this.$store.state.config;
    }

    public gotoStore() {
        if (this.$q.platform.is.android) {
            openURL(this.config.mobileLinks.android);
        } else if (this.$q.platform.is.ios) {
            openURL(this.config.mobileLinks.ios);
        }
    }

    public dismissBanner() {
        this.$store.dispatch('dismissMobleBanner');
    }

    public mounted() {
        console.log('TryMobileBanner: mounted()');
    }

}

